import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  FindOneInstitutionalCodes,
  FindOneInstitutionalCodesVariables,
} from '__generatedTypes__/FindOneInstitutionalCodes'
import { FIND_ONE_INSTITUTIONAL_CODES } from 'queries/institutionalCodes'

export function useFindOneInstitutionalCodesQuery(
  options?: QueryHookOptions<FindOneInstitutionalCodes, FindOneInstitutionalCodesVariables>
) {
  return useQuery<FindOneInstitutionalCodes, FindOneInstitutionalCodesVariables>(FIND_ONE_INSTITUTIONAL_CODES, options)
}
